module.exports = __webpack_public_path__ + "static/img/tools_bg03.23cf46a5.png";